export function DocumentIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.60001 3.2C3.60001 2.53726 4.13726 2 4.80001 2H22.4C22.7183 2 23.0235 2.12643 23.2485 2.35147L28.0485 7.15147C28.2736 7.37652 28.4 7.68174 28.4 8V28.8C28.4 29.4627 27.8627 30 27.2 30H4.80001C4.13726 30 3.60001 29.4627 3.60001 28.8V3.2ZM6.00001 4.4V27.6H26V8.49706L21.903 4.4H6.00001Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6 11.6C13.6 10.9373 14.1373 10.4 14.8 10.4H22C22.6627 10.4 23.2 10.9373 23.2 11.6C23.2 12.2627 22.6627 12.8 22 12.8H14.8C14.1373 12.8 13.6 12.2627 13.6 11.6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6 16.4C13.6 15.7373 14.1373 15.2 14.8 15.2H20.4C21.0627 15.2 21.6 15.7373 21.6 16.4C21.6 17.0627 21.0627 17.6 20.4 17.6H14.8C14.1373 17.6 13.6 17.0627 13.6 16.4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6 21.2C13.6 20.5373 14.1373 20 14.8 20H22C22.6627 20 23.2 20.5373 23.2 21.2C23.2 21.8627 22.6627 22.4 22 22.4H14.8C14.1373 22.4 13.6 21.8627 13.6 21.2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.80001 16.4C8.80001 15.7373 9.33726 15.2 10 15.2H10.8C11.4627 15.2 12 15.7373 12 16.4C12 17.0627 11.4627 17.6 10.8 17.6H10C9.33726 17.6 8.80001 17.0627 8.80001 16.4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.80001 11.6C8.80001 10.9373 9.33726 10.4 10 10.4H10.8C11.4627 10.4 12 10.9373 12 11.6C12 12.2627 11.4627 12.8 10.8 12.8H10C9.33726 12.8 8.80001 12.2627 8.80001 11.6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.80001 21.2C8.80001 20.5373 9.33726 20 10 20H10.8C11.4627 20 12 20.5373 12 21.2C12 21.8627 11.4627 22.4 10.8 22.4H10C9.33726 22.4 8.80001 21.8627 8.80001 21.2Z"
        fill="currentColor"
      />
    </svg>
  )
}
